
import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';
import { Producto } from './producto.model';

@Injectable()
export class ProductoResolver implements Resolve<Producto> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Producto);
      }
      return await this.backendService.get(Producto, Producto.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/productos']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/producto.resolver.ts